<template lang="html">
    <div class="container mountain-biking">
        <h2>Mountain Biking</h2>
        <div class="container">
            <p>
                A sport I gave up for years after a pair of gnarly crashes shook my nerves, upon moving to Colorado the bug bit me again. A great passtime on days when climbing partners are hard to find, the beautiful landscapes of Colorado have really inspired me to get out and ride. A big shout out to the <a href="https://bouldermountainbike.org/">Boulder Mountainbike Alliance</a> for all the hard work they put in to make the area a great place for everyone to enjoy.
            </p>
            <p>
                Heil Valley Ranch is one of my favorite biking locales near Boulder, the Wapiti trail there is a quad burner on the way up, and a blast on the way down. The Ponderosa Loop is fantastically flowy fun with a great view a couple of miles in. The Picture Rock trail can be a great way to get to the top if you want to aboid the burnination caused by the Wapiti Trail and affords a less technical but still wickedly fun descent.
            </p>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'MountainBiking'
    };

</script>

<style lang="postcss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/interests/hobbies/mountain-biking.vue